import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import label from "../../labels/accessRightsManagement_en.json";
import { useForm } from "react-hook-form";
import commonLabels from "../../../common/labels/common_en.json";
import _ from "lodash/fp";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  saveDepartmentData,
  saveNewUserData,
} from "../../actions/accessRightsManagementActions";
const UpdateDepartment = (props) => {
  const { register, handleSubmit, formState, errors, watch } = useForm({
    mode: "onChange",
  });
  const dispatch = useDispatch();
  const [updateDepartmentName, setUpdateDepartmentName] = useState("");
  const [updateDiscription, setUpdateDiscription] = useState("");
  const [updateIsActive, setUpdateIsActive] = useState(
    props.setUpdateData.isActive
  );

  const onSubmit = () => {
    let data = {
      id: props.setUpdateData.id,
      name: updateDepartmentName || props.setUpdateData.name,
      description: updateDiscription || props.setUpdateData.description,
      isActive: updateIsActive,
      isDeleted: false,
    };

    dispatch(saveDepartmentData(data));

    props.setShowEditModal(false);
  };
  const onhandleisActive = (ele) => {
    setUpdateIsActive(ele.target.checked);
  };
  return (
    <Modal
      size="xm"
      show={props.showEditModal}
      onHide={() => {
        props.setShowEditModal(false);
      }}
      aria-labelledby="example-modal-sizes-title-xs"
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-xs">
          Update Department
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-md-6">
            <label className="float-left">
              {label.DepartmentName}
              <span className="errorText">*</span>
            </label>
            <input
              type="text"
              name="departmentName"
              defaultValue={props.setUpdateData.name}
              onChange={(e) => {
                setUpdateDepartmentName(e.target.value);
              }}
              className="form-control"
              maxLength={25}
              ref={register({ required: true })}
            />
            {_.get("departmentName.type", errors) === "required" && (
              <p className="errorText float-left">
                {commonLabels.MANDATORY_FIELD_MESSAGE}
              </p>
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-md-8">
            <label className="float-left">
              {label.Description}
              <span className="errorText">*</span>
            </label>
            <textarea
              name="departmentdescription"
              defaultValue={props.setUpdateData.description}
              onChange={(e) => {
                setUpdateDiscription(e.target.value);
              }}
              className="form-control "
              ref={register({
                required: true,
                pattern: {
                  value: /^(?:(?!\s{2}).)*$/,
                },
              })}
              maxLength={100}
              rows={3}
            />
            {_.get("departmentdescription.type", errors) === "required" && (
              <p className="errorText float-left">
                {commonLabels.MANDATORY_FIELD_MESSAGE}
              </p>
            )}
            {_.get("departmentdescription.type", errors) === "pattern" && (
              <p className="errorText float-left">
                {commonLabels.InputInvalid}
              </p>
            )}
          </div>
        </div>
        <div className="row mb-2">
          <div className="col-md-3">
            <label className="float-left">
              {label.isActive}
              <span className="errorText">*</span>
            </label>
            <input
              type="checkbox"
              id="isActive"
              name="isActive"
              defaultChecked={updateIsActive}
              // checked={updateIsActive}
              onChange={(event) => onhandleisActive(event)}
            />
          </div>
        </div>
        <div className="row custom-button text-align-right">
          <button
            className="btn btn-secondary ml-auto mr-2"
            type="button"
            onClick={() => {
              props.setShowEditModal(false);
            }}
          >
            {label.Cancel}
          </button>
          <button
            className="btn btn-primary"
            onClick={handleSubmit((e) => {
              onSubmit(e);
            })}
          >
            {label.Save}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default UpdateDepartment;
